// TODO: old probing logic kept for reference

///import RFB_1_6_0 from "@src/vendor/noVNC-1.6.0/core/rfb";
///
///const NOVNC_CONFIGS = [
///  { version: "1.6.0", source: "local" },
///  { version: "1.4.0", source: "cdn" },
///  { version: "1.3.0", source: "cdn" },
///];
///
///const getCdnUrl = (version: string): string => {
///  return `https://cdn.jsdelivr.net/npm/@novnc/novnc@${version}/core/rfb.js`;
///};
///
///const loadRFBClass = async (config: (typeof NOVNC_CONFIGS)[0]) => {
///  if (config.source === "local") {
///    console.log("Using noVNC 1.6.0 directly from vendor sourcecode");
///    return RFB_1_6_0;
///  }
///
///  const url = getCdnUrl(config.version);
///  const module = await import(/* webpackIgnore: true */ url);
///  return module.default;
///};
///
///type VncProbeResult =
///  | "CONNECTED_NO_AUTH"
///  | "CONNECTED_WITH_AUTH"
///  | "AUTH_REQUIRED"
///  | "INCOMPATIBLE";
///
///const probeVncCompatibility = async (
///  RFBClass: any,
///  wsUrl: string,
///  password?: string,
///  timeoutMs = 10000,
///): Promise<VncProbeResult> => {
///  return new Promise((resolve) => {
///    // this container will hold the invisible VNC connection for probing
///    // needed to avoid visual artifacts and state conflicts with the real VNC connection,
///    // increase performance
///    const testContainer = document.createElement("div");
///    testContainer.style.position = "fixed";
///    testContainer.style.left = "-9999px";
///    testContainer.style.width = "1px";
///    testContainer.style.height = "1px";
///    document.body.appendChild(testContainer);
///
///    let testRfb: any;
///    let resolved = false;
///
///    const cleanup = () => {
///      if (testRfb) {
///        try {
///          testRfb.disconnect();
///        } catch (e) {
///          console.log("Error during testRfb disconnect:", e);
///        }
///      }
///      testContainer.remove();
///    };
///
///    const finish = (result: VncProbeResult) => {
///      if (resolved) return;
///      resolved = true;
///      cleanup();
///      resolve(result);
///    };
///
///    const timeout = setTimeout(() => {
///      finish("INCOMPATIBLE");
///    }, timeoutMs);
///
///    try {
///      // Create RFB with or without credentials
///      const options = password ? { credentials: { password } } : {};
///      testRfb = new RFBClass(testContainer, wsUrl, options);
///
///      testRfb.addEventListener("connect", () => {
///        clearTimeout(timeout);
///        finish(password ? "CONNECTED_WITH_AUTH" : "CONNECTED_NO_AUTH");
///      });
///
///      testRfb.addEventListener("credentialsrequired", () => {
///        if (password) {
///          // We have a password, try to authenticate
///          testRfb.sendCredentials({ password });
///        } else {
///          // No password provided, just report auth is required
///          clearTimeout(timeout);
///          finish("AUTH_REQUIRED");
///        }
///      });
///
///      testRfb.addEventListener("securityfailure", () => {
///        clearTimeout(timeout);
///        // Auth failed = this version is incompatible with this password
///        finish("INCOMPATIBLE");
///      });
///
///      testRfb.addEventListener("disconnect", () => {
///        clearTimeout(timeout);
///        finish("INCOMPATIBLE");
///      });
///    } catch {
///      clearTimeout(timeout);
///      finish("INCOMPATIBLE");
///    }
///  });
///};
///
///export const loadWorkingNoVnc = async (
///  wsUrl: string,
///  password?: string,
///): Promise<{
///  RFBClass: any;
///  version: string;
///  authRequired: boolean;
///}> => {
///  for (const config of NOVNC_CONFIGS) {
///    try {
///      console.log(`Testing noVNC ${config.version} from ${config.source}...`);
///
///      const RFBClass = await loadRFBClass(config);
///
///      if (typeof RFBClass !== "function") continue;
///
///      // First try without password
///      console.log(`Probing ${config.version} without auth...`);
///      let result = await probeVncCompatibility(RFBClass, wsUrl);
///
///      if (result === "CONNECTED_NO_AUTH") {
///        console.log(`Using noVNC ${config.version} (no auth required)`);
///        return { RFBClass, version: config.version, authRequired: false };
///      }
///
///      // If auth required and password provided, test with password
///      if (result === "AUTH_REQUIRED" && password) {
///        console.log(`Probing ${config.version} with auth...`);
///        result = await probeVncCompatibility(RFBClass, wsUrl, password);
///
///        if (result === "CONNECTED_WITH_AUTH") {
///          console.log(`Using noVNC ${config.version} (authenticated)`);
///          return { RFBClass, version: config.version, authRequired: true };
///        }
///
///        // Auth failed with this version, try next
///        console.warn(
///          `noVNC ${config.version} auth failed, trying next version...`,
///        );
///        continue;
///      }
///
///      // No password provided but auth required - return this version
///      // User will need to provide password
///      if (result === "AUTH_REQUIRED" && !password) {
///        console.log(
///          `Using noVNC ${config.version} (auth required, waiting for password)`,
///        );
///        return { RFBClass, version: config.version, authRequired: true };
///      }
///
///      console.warn(
///        `noVNC ${config.version} incompatible, trying next version...`,
///      );
///    } catch (err) {
///      console.warn(`Failed with noVNC ${config.version}:`, err);
///    }
///  }
///
///  throw new Error(
///    "No compatible VNC version found. Tried versions: " +
///      NOVNC_CONFIGS.map((c) => c.version).join(", "),
///  );
///};
///
///
///import RFB_1_6_0 from "@src/vendor/noVNC-1.6.0/core/rfb";
///
///export const loadWorkingNoVnc = async (
///  wsUrl: string,
///  password?: string
///): Promise<{
///  RFBClass: any;
///  version: string;
///  authRequired: boolean;
///}> => {
///
///  // Always return 1.6 and require auth (user will submit password)
///  return {
///    RFBClass: RFB_1_6_0,
///    version: "1.6.0",
///    authRequired: true, // so password input shows
///  };
///};

// logic for direct authentication attempt over same connection to not probe first and consume auth_key
import RFB_1_3_0 from "@src/vendor/noVNC-1.3.0/core/rfb";
import RFB_1_6_0 from "@src/vendor/noVNC-1.6.0/core/rfb";

export const NOVNC_VERSIONS = ["1.3.0", "1.6.0"] as const;
export type NoVncVersion = (typeof NOVNC_VERSIONS)[number];

export interface VncSettings {
  version: NoVncVersion;
  swapRB: boolean;
}

export const loadWorkingNoVnc = async (version: NoVncVersion = "1.3.0") => {
  const RFBClass = version === "1.6.0" ? RFB_1_6_0 : RFB_1_3_0;
  console.log(`Using noVNC ${version}`);
  return { RFBClass, version };
};
